import { api } from "@/api"
import { useQuery } from "@tanstack/vue-query"

export type OrganizationConfig = {
  businessFundingEnabled: boolean
  appName: string
  smsServiceEnabled: boolean
  productImportsEnabled: boolean
}

export const retrieveSelfOrg = async () => {
  const { body } = await api.get<OrganizationConfig>(
    "/get-organization-config/"
  )
  return body
}

export const useOrganizationConfig = () => {
  const { data } = useQuery({
    queryKey: [BASE_CURRENT_ORGANIZATION_CONFIG_QUERY_KEY],
    queryFn: retrieveSelfOrg,
  })

  return { organizationConfig: data }
}
